<template>
  <div>
    <L1 class="CouponScheduleList" :popup="addnew||itemSelected||deleteItem">
      <template slot="slot_title">
        <RoundBtn :bg="'var(--color-checked)'" :text="'新增票券'" :icon="'add'" @click="addnew=true"/>
        <Select1 :width="'360px'" :defaultValue="store" @input="store=$event" :style="{zIndex:1}">
          <option :value="null">全部區域</option>
          <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest">{{rest}}</option>
        </Select1>
        <searchVue :defaultValue="searchText" @input="searchText=$event"/>
        <Page50 :style="{marginLeft:'auto'}" :defaultValue="page" @input="page=$event" :max="Math.ceil(count/limit)"/>
      </template>
      <template>
      <Table :rows="coupons">
        <template slot="slot_head">
          <th :style="{}">票券別</th>
          <th :style="{}">活動名稱</th>
          <th :style="{}">贈品名稱</th>
          <th :style="{textAlign:'center'}">贈品圖片</th>
          <th :style="{width: '160px'}">兌換條件</th>
          <th :style="{textAlign:'start'}">使用期限</th>
          <th :style="{textAlign:'center'}">轉贈</th>
          <th :style="{textAlign:'center', width:'100px'}">線上兌換</th>
          <th :style="{textAlign:'start'}">更新時間</th>
          <th :style="{}">修改票券</th>
          <th :style="{}">刪除</th>
        </template>
        <tr slot-scope="{item, index}">
          <td><div class="票券別" :class="item.couponType" :style="{backgroundColor: `var(--${item.couponType})`}">{{item.couponType}}</div></td>
          <td>{{item.couponName}}</td>
          <td>{{item.productName}}<br>
            <span v-if="item.couponID" :style="{color: '#CACACA'}">{{item.couponID?.name}}  {{
                item.couponID.mode===1?`滿${item.couponID?.cond}折${item.couponID?.disc}元`:
                item.couponID.mode===2?`每${item.couponID?.cond}折${item.couponID?.disc}元`:
                item.couponID.mode===3?`滿${item.couponID?.cond}打${item.couponID?.disc}折`:
                item.couponID.mode===4?`指定商品折${item.couponID?.disc}元`:
                item.couponID.mode===5?`指定商品打${item.couponID?.disc}折`:''
                }}</span>
              <span :style="{color: '#CACACA'}">{{item.setID?.name}}  {{item.setID?.price?`$${item.setID?.price}`:''}}</span>
              <span :style="{color: '#CACACA'}">{{item.productID?.name}}  {{item.productID?.price?`$${item.productID?.price}`:''}}</span>
          </td>
          <td :style="{textAlign: 'center'}"><img class="thb" :src="item.image?.replace('/', '')"/></td>
          <td><div class="pointEx"><span>{{item.pointExchange}}</span> 點</div></td>
          <td>
            <div :key="`txt-${t}`" v-for="(txt, t) in item.使用期限.replace('訖', '|訖').split('|')" :style="{whiteSpace:'nowrap', textAlign: 'start'}">{{txt}}</div>
          </td>
          <td class="transfalse" :style="{textAlign:'center'}">{{item.CanBeTransferred?'':'X'}}</td>
          <td :style="{textAlign:'center'}"><div :style="{margin: 'auto', width: 'fit-content'}"><switchboxsVue :style="{gap:0}" :defaultValue="item.status==='成立' " @update="update(item._id, $event, index)"/></div></td>
          <td :style="{textAlign:'start'}">{{toDateTime(item.updateTime)}}</td>
          <td><EditBtn  :style="{margin: 'auto'}" @click="itemSelected=item"/></td>
          <td><DelBtn  :style="{margin: 'auto'}" @click="deleteItem=item"/></td>
            <!-- <td v-for="(field, i) in fields" :key="`item-${index}-${i}`">
              <div class="票券別" :class="item[field]" v-if="field==='票券別'" :style="{backgroundColor: `var(--${item['票券類型']})`}">{{item.票券類型}}</div>
              <div v-else-if="field==='贈品名稱'">{{item[field]}}<br>
              <span v-if="item.couponID" :style="{color: '#CACACA'}">{{item.couponID?.name}}  {{
                item.couponID.mode===1?`滿${item.couponID?.cond}折${item.couponID?.disc}元`:
                item.couponID.mode===2?`每${item.couponID?.cond}折${item.couponID?.disc}元`:
                item.couponID.mode===3?`滿${item.couponID?.cond}打${item.couponID?.disc}折`:
                item.couponID.mode===4?`指定商品折${item.couponID?.disc}元`:
                item.couponID.mode===5?`指定商品打${item.couponID?.disc}折`:''
                }}</span>
              <span :style="{color: '#CACACA'}">{{item.setID?.name}}  {{item.setID?.price?`$${item.setID?.price}`:''}}</span>
              <span :style="{color: '#CACACA'}">{{item.productID?.name}}  {{item.productID?.price?`$${item.productID?.price}`:''}}</span>
              </div>
              <div v-else-if="field==='點數'" :style="{color:'var(--highlight)', fontSize: '20px', fontWeight:'700'}">{{item.pointExchange}}</div>
              <img class="thb" v-else-if="field==='贈品圖片'" :src="item[field]?.replace('/', '')"/>
              <button :style="{margin: 'auto'}" :disabled="item['狀態']!=='成立'" v-else-if="field==='編輯推播'" class="編輯推播" @click="$router.push({ name: 'PushInformation', query: {type:'coupon', coupon: item._id} })"></button>
              <EditBtn  :style="{margin: 'auto'}" v-else-if="field==='修改票券'" @click="itemSelected=item"/>
              <DelBtn  :style="{margin: 'auto'}" v-else-if="field==='刪除'"  @click="deleteItem=item"/>
              <span v-else>{{item[field]}}</span></td> -->
        </tr>
      </Table>
      <template slot="popup">
        <NewCoupon :types="couponTypes" :Coupons="Coupons" :Sets="Sets" @new="createSuccess" v-if="addnew" :show="addnew" @close="addnew=false"/>
        <editCoupon :types="couponTypes" :Coupons="Coupons" :Sets="Sets" @updateItem="updateSuccess" v-if="itemSelected" :item="itemSelected" @close="itemSelected=null"/>
        <dialognoPadding2 :transparent="true" :label="'確認刪除'" @close="deleteItem=null" v-if="deleteItem" :show="deleteItem" :width="600">
          <div :style="{height: '150px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', justifyContent:'center'}">
            <p :style="{fontSize: '24px'}">確定要刪除"{{deleteItem.活動名稱}}"嗎?</p>
            <BtnsS @cancel="deleteItem=null" :save="'確定'" @save="deleteCoupon(deleteItem._id)"/>
          </div>
        </dialognoPadding2>
    </template>
    </template>
    </L1>
</div>
</template>

<script>
import RoundBtn from '../../components/btn/round.vue'
import L1 from '../../components/layout/L1.vue'
import Table from '../../components/tables/t2.vue'
import dialognoPadding2 from '../../components/dialognoPadding2.vue'
import NewCoupon from './NewCoupon.vue'
import editCoupon from './editCoupon.vue'
import EditBtn from '../../components/btn/edit.vue'
import DelBtn from '../../components/btn/del1.vue'
import { getapi, deleteapi, postapi } from '../../store/fetch'
import { mapState } from 'vuex'
import searchVue from '../../components/input/search.vue'
import Page50 from '../../components/input/page.vue'
import switchboxsVue from '../../components/radio/switch.vue'
export default {
  name: 'CouponScheduleList',
  components: {
    L1,
    Table,
    switchboxsVue,
    NewCoupon,
    RoundBtn,
    EditBtn,
    DelBtn,
    editCoupon,
    dialognoPadding2,
    searchVue,
    Page50
  },
  computed: {
    ...mapState({
      couponTypes: 'couponTypes',
      restaurants: 'restaurants'
    })
  },
  mounted () {
    this.getsets()
    this.getcoupons()
  },
  created () {
  },
  watch: {
    store () { this.getcoupons() },
    page () { this.getcoupons() },
    searchText () { this.getcoupons() }
  },
  methods: {
    async getsets () {
      this.Sets = await getapi('rest_product/category')
      this.Coupons = await getapi('discount?type=全部')
    },
    async deleteCoupon (id) {
      const ret = await deleteapi(`pointExchange/${id}`)
      if (ret) {
        const index = this.coupons.map(e => e._id).indexOf(id)
        this.coupons.splice(index, 1)
        this.deleteItem = null
      }
    },
    async update (id, value, index) {
      console.log('value', value)
      const ret = await postapi(`pointExchange/${id}`, { status: value ? '成立' : '暫存' })
      if (ret) {
        this.coupons[index] = ret
      }
    },
    updateSuccess (data) {
      const index = this.coupons.map(e => e._id).indexOf(data._id)
      this.coupons.splice(index, 1, data)
      this.itemSelected = null
    },
    createSuccess (data) {
      this.coupons.unshift(data)
      this.addnew = false
    },
    async getcoupons () {
      const params = {
        page: this.page,
        limit: this.limit
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      if (this.status) {
        params.status = this.status
      }
      if (this.store) {
        params.store = this.store
      }
      const { count, data } = await getapi(`pointExchange/list?${new URLSearchParams(params)}`)
      this.coupons = data
      this.count = count
    }
  },
  data () {
    return {
      store: null,
      TEXT: null,
      deleteItem: null,
      Coupons: [],
      Sets: [],
      count: 0,
      itemSelected: null,
      coupons: [],
      page: 1,
      limit: 8,
      addnew: false,
      searchText: null,
      fields: [
        '票券別',
        '活動名稱',
        '贈品名稱',
        '贈品圖片',
        '點數',
        '狀態',
        '使用期限',
        '更新時間',
        '編輯推播',
        '修改票券',
        '刪除'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.transfalse {
  color: var(--unnamed, #6D6D6D);
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 2.4px;
}
.pointEx {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: .5em;
  span {
    color: var(--unnamed, #FF8B8B);
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 2.8px;
  }
}
table {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  tr {
    display: table-row;
  }
  thead {
    display: table-header-group;
    tr {
      height: 40px;
      background-color: var(--color-infobox);
    }
  }
  tbody {
    display: table-row-group;
    tr {
      height: 65px;
    }
  }
}
.addBtn {
  background-color: var(--color-checked);
  width: 150px;
  height: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  border-radius: 25px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 0;
  margin: 0;
  gap: 3px;
  &::before {
    content: '';
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    width: 29px;
    height: 29px;
    background-image: url(./plus.svg);
  }
}
button {
  &.編輯推播 {
    width: 37px;
    height: 37px;
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    margin: auto;
    background-image: url(./edit.svg);
    background-repeat: no-repeat;
    background-size: 30px;
    background-position: center;
    &:disabled {
      position: relative;
      filter: contrast(.5);
      &:hover::before {
        content: '票券成立後，可進行推播';
        position: absolute;
        top: 40px;
        transform: translateX(-50%);
        width: fit-content;
        min-width: 230px;
        text-align: center;
        color: var(--color-letter);
      }
    }
  }
}
.thb {
  width: 100px;
  height: 80px;
  margin-inline: auto;
}
th, td {
  padding-inline: 5px;
  box-sizing: border-box;
  // border-right: 1px solid #C4C4C4;
  text-align: start;
  &:nth-child(1) { width: 140px; }
  &:nth-child(2) { width: 353px; }
  &:nth-child(3) { width: 292px; }
  &:nth-child(4) { width: 126px; }
  &:nth-child(5) { width: 60px; text-align: center; }
  &:nth-child(6) { width: 125px; text-align: center; }
  &:nth-child(7) { width: 130px; }
  &:nth-child(8) { width: 160px; }
  &:nth-child(9) { width: 150px; text-align: center; }
  &:nth-child(10) { width: 106px; text-align: center; }
  &:nth-child(11) { width: 106px; text-align: center; }
  &:nth-child(12) { width: inherit; text-align: center; }
  div.票券別 {
    width: 100px;
    height: 40px;
    background-color: var(--color-checked);
    color: #FFFFFF;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    letter-spacing: 0.1em;
    &.排程預約 {
      background-color: #CCA16E;
    }
  }
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-letter);
}
.addTeam, .importData {
  &:disabled {
    filter: contrast(.5)
  }
  width: 150px;
  height: 50px;
  background: transparent;
  border-radius: 50px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  border:none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  gap: 10px;
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(./assets/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }

}
select {
  box-sizing: border-box;
  width: 175px;
  height: 40px;
  border: 1px solid #C4C4C4;
  border-radius: 3px;
  text-indent: 12px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
}
input[type=radio] {
  width: 125px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.CouponScheduleList {
padding-inline: 18px 9px!important;
table {
  min-height: 300px;
  tbody  > tr {
    height: 98px;
    border-bottom: 1px solid var(--color-border);
  }
  tr.selected {
    background-color: var(--color-selected);
  }

}
.header {
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  color: var(--color-pri);
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  gap: 20px;
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
</style>
